/*
    Convierte cualquier error de Axios a una forma estable para toda la app.
    IMPORTANTE: el backend ya filtra SQL, stacks y secretos. Aca preservamos
    message/detail/errors/requestId para que la UI pueda explicar que paso.
*/

const TO_MESSAGE = (value, fallback = "Error en la solicitud.") => {
    if (Array.isArray(value)) return value.filter(Boolean).join(" | ") || fallback;
    if (typeof value === "string" && value.trim()) return value.trim();
    return fallback;
};


export const FORMAT_API_ERROR_MESSAGE = (error, fallback = "No se pudo completar la operación.") => {
    const message = error?.message || error?.data?.message || fallback;
    const detail = error?.detail || error?.data?.detail || null;
    const requestId = error?.requestId || error?.data?.requestId || null;

    return [
        message,
        detail && detail !== message ? detail : null,
        requestId ? `Referencia: ${requestId}` : null,
    ].filter(Boolean).join("\n");
};

export const HANDLE_AXIOS_ERROR = (ERROR) => {
    if (ERROR?.code === "ERR_NETWORK" || ERROR?.message === "Network Error") {
        return {
            status: 503,
            success: false,
            code: "NETWORK_ERROR",
            message: "No se pudo conectar con el servidor.",
            detail: "Verificá que el backend PHP esté levantado en el puerto 4000 y que la URL de la API sea correcta.",
            errors: null,
            requestId: null,
            data: null,
        };
    }

    if (!ERROR?.response) {
        return {
            status: 503,
            success: false,
            code: "NO_SERVER_RESPONSE",
            message: "El servidor no respondió a la solicitud.",
            detail: typeof ERROR?.message === "string" ? ERROR.message : null,
            errors: null,
            requestId: null,
            data: null,
        };
    }

    const responseData = ERROR.response.data ?? {};
    const headers = ERROR.response.headers ?? {};
    const errors = responseData?.errors && typeof responseData.errors === "object" && !Array.isArray(responseData.errors)
        ? responseData.errors
        : null;

    let message = TO_MESSAGE(responseData?.message || responseData?.msg || responseData?.error);

    if (!responseData?.message && Array.isArray(responseData?.errors)) {
        message = responseData.errors.join(" | ");
    }

    return {
        status: ERROR.response.status,
        success: false,
        code: responseData?.code || `HTTP_${ERROR.response.status}`,
        message,
        detail: responseData?.detail || null,
        errors,
        requestId: responseData?.requestId || headers?.["x-request-id"] || null,
        data: responseData,
    };
};
